import React from 'react';

import {Image} from '@udemy/react-core-components';

import {ubLogoUrl} from '../../utils/udemy-logo-urls';

const defaultUbLogoUrl = ubLogoUrl;

interface DemoFormHeaderUFBLogoProps {
    onClick?: () => void;
    imgWidth: number;
    imgHeight: number;
    ubLogoUrl?: string;
    href?: string;
    logoClassName?: string;
}

export const DemoFormHeaderUFBLogo = ({
    onClick,
    imgWidth,
    imgHeight,
    href,
    logoClassName,
    ubLogoUrl = defaultUbLogoUrl,
}: DemoFormHeaderUFBLogoProps) => {
    return (
        <a onClick={onClick} href={href}>
            <Image
                src={ubLogoUrl}
                alt="Udemy Business"
                width={imgWidth}
                height={imgHeight}
                data-purpose="ufb-name"
                className={logoClassName}
            />
        </a>
    );
};
